<template>
    <div v-if="page_init">
        <navTitle title="Hoạt động bàn xoay lớn" :share="true" askName="share" :shareUrl="share_url"/>
        <div style="text-align: center;margin-top: 2rem;font-size: .5rem;color: #d4d8dd" v-if="is_active">
            Sự kiện vẫn chưa mở
        </div>
        <div v-else>
            <div style="height: 1rem"></div>
            <!--        <Wealth :data="{now_money1:now_money1,now_money2:now_money2,points:points}"/>-->
            <div class="rule" v-html="data.rule"></div>
            <div class="join-title">
                Hôm nay có {{data.time_limit}} lượt rút thăm may mắn, tôi đã tham gia lần {{data.today_num}}
                <!--            今日可抽奖{{data.times_limit}}次，我已参与{{data.today_num}}次-->
            </div>
            <div class="turntable">
                <LuckyWheel ref="myLucky" width="300px" height="300px"
                            :prizes="prizes" :blocks="blocks" :buttons="buttons"
                            @start="startCallback" @end="endCallback"/>
            </div>
            <div class="progress-info">
                <div class="content" v-if="parseInt(data.all_turntable_count)!==0">
                    <div class="progress-title">Tổng tiến độ tham gia quay vòng hôm nay</div>
                    <progress
                            :value="Math.ceil((parseInt(data.today_all_num) / parseInt(data.all_turntable_count)) * 100)"
                            max="100" style="width: 100%"/>
                    <div class="progress-amount">{{data.today_all_num}}/{{data.all_turntable_count}}</div>
                </div>
                <div class="content" v-if="parseInt(data.share_gift)!==0">
                    <div class="progress-title">Chia sẻ của tôi đầy đủ</div>
                    <progress :value="Math.ceil((parseInt(data.share_num) / parseInt(data.share_gift)) * 100)" max="100"
                              style="width: 100%"/>
                    <div class="progress-amount">{{data.share_num}}/{{data.share_gift}}</div>
                </div>
            </div>
            <!--成功弹窗-->
            <div class="sign">
                <div class="signTip acea-row row-center-wrapper"
                     :class="active === true ? 'on' : ''">
                    <div class="signTipLight loadingpic"></div>
                    <div class="signTipCon">
                        <div class="state">{{uc_title}}</div>
                        <div v-html="uc_info" class="integral"></div>
                        <div class="signTipBnt" @click="closeAward">Sure</div>
                    </div>
                </div>
                <div class="mask" @touchmove.prevent :hidden="active === false"></div>
            </div>
            <div style="height: 1rem"></div>
        </div>
    </div>
</template>

<script>
    import {DebounceBy, getUserInfo, getTurntable, startTurntable} from "../../api/user"
    import navTitle from "../../components/navTitle"
    // import Wealth from "../../components/Wealth"
    // import {Button} from "mint-ui"

    export default {
        name: "Turntable",
        components: {
            navTitle,
            // Wealth,
            // Button
        },
        data() {
            return {
                page_init: false,
                active: false,
                is_active: false,
                share_url: '',
                now_money1: 0,
                now_money2: 0,
                points: 0,
                uc_title: '',
                uc_info: '',
                data: '',
                text_top: '10%',
                text_top1: '30%',
                img_top: '30%',
                img_width: 32,
                font_color: 'red',
                background1: '#F0F8FF',
                background2: '#87CEFB',
                blocks: [{padding: '13px', background: '#00c3f9'}],
                prizes: [],
                buttons: [{
                    radius: '17%',
                    background: '#00c3f9',
                    pointer: true,
                    fonts: [{text: 'Start', top: '-10px', fontSize: '15px', fontColor: '#fff'}]
                }],
            }
        },
        mounted() {
            this.getUserInfo()
            this.getTurntable()
        },
        methods: {
            closeAward() {
                this.getTurntable()
                this.active = false
                this.$dialog.toast({mes: 'Phần thưởng bánh xe đã được nâng cấp'})
            },
            getUserInfo() {
                let that = this
                getUserInfo().then(res => {
                    if (res.status === 200) {
                        that.now_money1 = parseFloat(res.data.now_money)
                        that.now_money2 = parseFloat(res.data.now_money2)
                        that.points = res.data.integral
                        that.share_url = window.location.protocol + '//'
                            + window.location.host + '/turntable?source=' + res.data.uid
                        // const user_level = parseInt(res.data.level)
                        this.page_init = true
                    }
                })
            },
            getTurntable() {
                let that = this
                getTurntable().then(res => {
                    if (res.status === 200) {
                        that.prizes = []
                        const data = res.data
                        that.data = data
                        const list = data.t_info

                        list.forEach((item, index) => {
                            let img_src, background = ''
                            if (parseInt(item.type) === 1)
                                img_src = ''
                            if (parseInt(item.type) === 2)
                                img_src = '₫'
                            if (parseInt(item.type) === 3)
                                img_src = 'Điểm'
                            if (index % 2 === 0)
                                background = that.background1
                            else
                                background = that.background2
                            let param = {
                                fonts: [{text: item.name, top: that.text_top}, {
                                    text: img_src,
                                    top: that.text_top1,
                                    fontColor: that.font_color
                                }],
                                // imgs: [{src: img_src, width: that.img_width, top: that.img_top}],
                                background: background,
                                type: item.type
                            }
                            that.prizes.push(param)
                        })
                    }
                }).catch(err => {
                    if (err.msg === 'Sweepstakes is closed')
                        that.is_active = true
                })
            },
            // 点击抽奖按钮会触发star回调
            startCallback: DebounceBy(function () {
                const urlParams = new URLSearchParams(window.location.search);
                const sourceParam = urlParams.get('source');
                let source = sourceParam === null ? 0 : sourceParam

                startTurntable({source: source}).then(res => {
                    // console.log(res)
                    if (res.status === 200) {
                        // 调用抽奖组件的play方法开始游戏
                        this.$refs.myLucky.play()
                        let index = res.data
                        setTimeout(() => {
                            // 假设后端返回的中奖索引是0
                            // 调用stop停止旋转并传递中奖索引
                            this.$refs.myLucky.stop(index[0])
                        }, 3000)
                    }
                }).catch(err => {
                    const response = err.data
                    if (response.data.code === 6000)
                        return this.$dialog.toast({mes: response.data.msg})
                    if (response.data.code === 6001) {
                        let num = parseInt(this.data.times_limit) - parseInt(this.data.today_num)
                        this.$dialog.confirm({
                            mes: `Hôm nay bạn vẫn còn <b style="color: red">${num}</b> cơ hội rút thăm may mắn, hãy hoàn thành nhiệm vụ trước để có cơ hội rút thăm may mắn`,
                            title: "Mẹo",
                            opts: [
                                {
                                    txt: "Chắc chắn",
                                    color: "#00C3F9",
                                    callback: () => {
                                        // this.$router.push({path: '/user/Recharge_cash'})
                                    }
                                }
                            ]
                        })
                    }
                })
            }),
            // 抽奖结束会触发end回调
            endCallback(prize) {
                let type = parseInt(prize.type)
                let number = parseInt(prize.fonts[0].text)
                let img_src
                if (type === 1) {
                    this.now_money2 = this.now_money2 + number
                    img_src = 'hj'
                }
                if (type === 2) {
                    this.now_money1 = this.now_money1 + number
                    img_src = '₫'
                }
                if (type === 3) {
                    this.points = this.points + number
                    img_src = 'Điểm'
                }
                this.uc_title = 'Chúc mừng'
                this.uc_info = `${img_src} ${number}`
                this.active = true
            },
        }

    }
</script>

<style scoped>
    .turntable {
        padding: 30px 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .rule {
        padding: 10px;
        font-size: .2rem;
        color: #8c939d;
    }

    .join-title {
        text-align: center;
        color: #4d4d4d;
        font-size: .27rem;
    }

    .content {
        margin: .1rem 0;
        padding: .1rem;
        background-color: #fff;
    }

    .progress-title {
        font-size: .2rem;
        color: #8c939d;
    }

    /* IE10 */
    progress {
        height: 7px;
        background-color: #00c3f9 !important;
    }

    /* Firefox */
    progress::-moz-progress-bar {
        height: 7px;
        background-color: #00c3f9 !important;
    }

    /* Chrome */
    progress::-webkit-progress-value {
        height: 7px;
        background-color: #00c3f9 !important;
    }

    .progress-amount {
        font-size: .25rem;
        margin-top: .1rem;
        text-align: right;
    }
</style>